// Vendors
import $ from 'jquery';
import 'waypoints/lib/jquery.waypoints.min';

const selectorClassName = 'site-header__bottom';
const selector = `.${selectorClassName}`;

// Create waypoint for site header bottom
$(selector).waypoint(
  direction => {
    if (direction === 'down')
      $('body').addClass(`${selectorClassName}-is-stuck`);
    else if (direction === 'up')
      $('body').removeClass(`${selectorClassName}-is-stuck`);
  },
  { offset: 0 }
);
